/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type ZteRowFragment = { __typename?: 'ZteBatch', id: string, downloadUrl?: string | null, batchName: string, claimedDisplay?: number | null, createdAt: any, customerName?: string | null, fileName: string, organizationName?: string | null, pairedDisplay?: number | null, status: string, totalDisplay?: number | null, unClaimedDisplay?: number | null, validated?: number | null, createdBy?: string | null };

export const ZteRowFragmentDoc = gql`
    fragment ZteRow on ZteBatch {
  id
  downloadUrl
  batchName
  claimedDisplay
  createdAt
  customerName
  fileName
  organizationName
  pairedDisplay
  status
  totalDisplay
  unClaimedDisplay
  validated
  createdBy
}
    `;